import { getAnalyticsExternalData } from '@/_utils';
import { LANDING_URL } from '@/layouts/app-layout/_constants';
import { ECountry, ELanguage } from '@portals/help-center-core';
import { resolveUrl } from '@portal-root/geo-utils';
import { getValidLocale } from '@/utils/get-valid-locale';

export const UTM_PARAMS = {
  utm_source: 'prowb',
  utm_medium: 'webinar',
  utm_campaign: 'wbpro',
  utm_content: 'helpcenter',
};
const UTM_PARAMS_STRING = new URLSearchParams(UTM_PARAMS).toString();

type TProps = {
  country: ECountry;
  locale: string;
  href: string;
};

export const getPortalLandingUrl = ({ country, locale, href }: TProps) => {
  const { idSupplier } = getAnalyticsExternalData();

  if (idSupplier) {
    return href;
  }

  const landingUrl = resolveUrl(LANDING_URL);

  if (country === ECountry.CHINA) {
    // для китая лендинг не принимает страну - только язык
    return `${landingUrl}/${ELanguage.CHINESE_CORRECT}?${UTM_PARAMS_STRING}`;
  }

  return `${landingUrl}/${country}/${locale}?${UTM_PARAMS_STRING}`;
};
